<ion-app>
  
  <ion-split-pane contentId="main-content">
    <ion-menu #ionMenu contentId="main-content" type="overlay" [style.width]="showSideMenu ? 'fit-content' : '1px'">
      <ion-header>
        <ion-toolbar>
          <ion-title (click)="ionMenu.toggle()" class="p0">
            <ion-icon *ngIf="usingCollapsingSideMenu" name="chevron-back-outline"></ion-icon>
            <img *ngIf="!widerSideMenu" src="./assets/bee.png"/>
            <img *ngIf="widerSideMenu" src="./assets/image/cb-logo-flat.png"/>
          </ion-title>
        </ion-toolbar>
      </ion-header>

      <ion-content>

        <div class="side-menu-wrap">

          <ion-list>
            <ng-container *ngIf="currentCommunity != null && currentCommunity.communityId > 0 && inNewCommunity === false">

              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" routerLink="/engagement" lines="none" detail="false"
                  routerLinkActive="selected" (click)="clearFundraiser()">
                  <ion-label class="ion-text-wrap ion-text-center">
                    <ion-icon slot="start" name="megaphone-outline"></ion-icon>
                    <p>Engagement</p>
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>

              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" routerLink="/news" lines="none" detail="false"
                  routerLinkActive="selected" (click)="clearFundraiser()">
                  <ion-label class="ion-text-wrap ion-text-center">
                    <ion-icon slot="start" name="newspaper-outline"></ion-icon>
                    <p>News</p>
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>

              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" routerLink="/events" lines="none" detail="false"
                  routerLinkActive="selected" (click)="clearFundraiser()">
                  <ion-label class="ion-text-wrap ion-text-center">
                    <ion-icon slot="start" name="calendar-outline"></ion-icon>
                    <p>Events</p>
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>
              
              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" routerLink="/marketplace" lines="none" detail="false"
                  routerLinkActive="selected" (click)="clearFundraiser()">
                  <ion-label class="ion-text-wrap ion-text-center">
                    <ion-icon slot="start" name="cart-outline"></ion-icon>
                    <p>Marketplace</p>
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>
              
              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" routerLink="/memberships" lines="none" detail="false"
                  routerLinkActive="selected" (click)="clearFundraiser()">
                  <ion-label class="ion-text-wrap ion-text-center">
                    <ion-icon name="id-card-outline"></ion-icon>
                    <p>Memberships</p>
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>

              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" routerLink="/surveys" lines="none" detail="false"
                  routerLinkActive="selected" (click)="clearFundraiser()">
                  <ion-label class="ion-text-wrap ion-text-center">
                    <ion-icon name="clipboard-outline"></ion-icon>
                    <p>Surveys</p>
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>

              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" routerLink="/fundraising" lines="none" detail="false"
                  routerLinkActive="selected" (click)="clearFundraiser()">
                  <ion-label class="ion-text-wrap ion-text-center">
                    <ion-icon slot="start" name="logo-usd"></ion-icon>
                    <p>Fundraising</p>
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>
              
              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" routerLink="/users" lines="none" detail="false"
                  routerLinkActive="selected" (click)="clearFundraiser()">
                  <ion-label class="ion-text-wrap ion-text-center">
                    <ion-icon slot="start" name="people-outline"></ion-icon>
                    <p>Users</p>
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>
                
              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" routerLink="/content" lines="none" detail="false"
                  routerLinkActive="selected" (click)="clearFundraiser()">
                  <ion-label class="ion-text-wrap ion-text-center">
                    <ion-icon slot="start" name="file-tray-full-outline"></ion-icon>
                    <p>Content</p>
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>

              <ion-menu-toggle auto-hide="false">
                <ion-item routerDirection="root" routerLink="/community" detail="false"
                  routerLinkActive="selected" (click)="clearFundraiser()">
                  <ion-label class="ion-text-wrap ion-text-center">
                    <ion-icon slot="start" name="settings-outline"></ion-icon>
                    <p>Community Setup</p>
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>

            </ng-container>

          </ion-list>

          <div>
            <!-- <ion-menu-toggle auto-hide="false" *ngIf="isL57 || (currentCommunity != null && currentCommunity.communityId > 0)">
              <ion-item routerDirection="root" routerLink="/support/tickets" routerLinkActive="selected"
                detail="false" lines="none" (click)="clearFundraiser()">
                <ion-label class="ion-text-wrap ion-text-center">
                  <ion-icon slot="start" name="help-buoy-outline"></ion-icon>
                  <p>Support</p>
                </ion-label>
              </ion-item>
            </ion-menu-toggle> -->

            <ion-menu-toggle auto-hide="false">
              <ion-item routerDirection="root" routerLink="/home/communities" routerLinkActive="selected"
                detail="false" lines="none" (click)="clearFundraiser()">
                <ion-label class="ion-text-wrap ion-text-center">
                  <ion-icon slot="start" name="business-outline"></ion-icon>
                  <p>My Communities</p>
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            <div class="version">
              {{buildInfo}}
            </div>
          </div>
        </div>

      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>


<!-- <app-help-bubble [pageKey]="helpRoute"></app-help-bubble> -->
<!-- <div id="route" *ngIf="isL57" (click)="setClipboard()">{{helpRoute}}</div> -->